import * as React from "react";
const SecurityIcon = (props) => (
  <svg
    width={32}
    height={40}
    viewBox="0 0 32 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 40C11.3667 38.8333 7.54133 36.1747 4.524 32.024C1.50667 27.8733 -0.00133245 23.2653 8.83392e-07 18.2V6L16 0L32 6V18.2C32 23.2667 30.492 27.8753 27.476 32.026C24.46 36.1767 20.6347 38.8347 16 40ZM16 35.8C19.2333 34.8 21.9333 32.8247 24.1 29.874C26.2667 26.9233 27.5333 23.632 27.9 20H16V4.25L4 8.75V19.1C4 19.3333 4.03333 19.6333 4.1 20H16V35.8Z"
      fill="url(#paint0_linear_2492_12816)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2492_12816"
        x1={16}
        y1={5.01774e-8}
        x2={18.1047}
        y2={53.5745}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#024A73" />
        <stop offset={0.46875} stopColor="#16587E" />
        <stop offset={1} stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
export default SecurityIcon;
